import React from 'react';
import { MdAttachment } from 'react-icons/md';
import { useSearchHistory } from '../context';

const AttachmentsCell = ({ data }) => {
    const { setAttachments, showAttachmentsModal } = useSearchHistory();

    const hasDocs = Array.isArray(data.documents)
        && data.documents.length > 0;

    return hasDocs ? (
        <span className='flex items-center justify-center text-primary-40 text-2xl'>
            <button 
                className='px-4 py-2 -my-2 rounded-full hover:bg-blue-10 focus:outline-none'
                onClick={() => {
                    setAttachments(data.documents);
                    showAttachmentsModal();
                }}
            >
                <MdAttachment />
            </button>
        </span>
    ) : (<></>);
};

export default AttachmentsCell;